export default __webpack_public_path__ + "static/media/slide10.0e20a50a.jpg";